import { Component, OnInit } from '@angular/core';
import { GruposService } from 'src/app/services/grupos.service';
import { Subject } from 'rxjs';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-fondos',
  templateUrl: './fondos.component.html',
  styleUrls: ['./fondos.component.scss']
})
export class FondosComponent implements OnInit {
  enviroment = environment.BASE_URL;
  respuestaFondos:any;
  fondos;
  dtOptions: DataTables.Settings = {
    dom: 'tip',                      // Estructura de la tabla     --> https://datatables.net/reference/option/dom
    lengthMenu: [],                      // Menú de tamaños de página   --> https://datatables.net/reference/option/lengthMenu
    order: [1, 'desc'],
    paging: true,
    pagingType: 'simple_numbers',
    pageLength: 10,
  };
  dtTrigger: Subject<any> = new Subject();

  respuestaAgregar:any;
  respuestaEditar:any;
  respuestaUpdate:any;

  datosItem;
  itemId;
  data;

  formulario;
  formularioEdit;

  constructor( private _getFondos: GruposService, private _agregarFondo: CatalogosService, private _editarFondo:CatalogosService,
    private _updateFondo: CatalogosService, private modalService: NgbModal, private iziToast: Ng2IzitoastService) { }

  ngOnInit(): void {
    this.getFondos();

    this.formulario = {
      'nombre':'',
    }

    this.formularioEdit = {
      'nombre':'',
    }

  }

  getFondos(){
    this._getFondos.getFondos().subscribe(
      data => {
        this.respuestaFondos = data;
        if(this.respuestaFondos.success){
          this.fondos = this.respuestaFondos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarFondo(){
    this.data = {
      'nombre': this.formulario.nombre,
    }

    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }

    this._agregarFondo.agregarFondo(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getFondos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }


  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen2').focus();
      return;
    }
  }

  editarFondo(fondo){
    this.data = {
      'fondo':fondo,
    }
    this._editarFondo.editarFondo(this.data).subscribe(
      data => {
        this.respuestaEditar= data;
        if(this.respuestaEditar.success){
          this.datosItem = this.respuestaEditar.content;
          this.formularioEdit.nombre = this.datosItem.nombre;
          this.itemId = fondo;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateFondo(fondo){
    this.data = {
      'fondo': fondo, 
      'nombre': this.formularioEdit.nombre,
    }

    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('fondo', fondo);
    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    this._updateFondo.updateFondo(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getFondos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
